var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{staticClass:"text-left form-control",class:_vm.customClass,attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"mask":[
    /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
    /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
    /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '/',
    /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-',
    /\d/, /\d/
  ],"guide":false},on:{"change":_vm.callChange,"keyup":_vm.callKeyUp,"blur":function($event){return _vm.searchCNPJ(_vm.cnpj)}},model:{value:(_vm.cnpj),callback:function ($$v) {_vm.cnpj=$$v},expression:"cnpj"}})
}
var staticRenderFns = []

export { render, staticRenderFns }